import React from "react"
import PropTypes from "prop-types"
import {
  FaUpload,
  FaLinkedin,
  FaFacebook,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa"

const Form = ({
  handleSubmit,
  fullName,
  setFullName,
  email,
  setEmail,
  linkedin,
  setLinkedin,
  handleChangeUploadResume,
  message,
  setMessage,
  loading,
}) => {
  return (
    <form className="flex flex-wrap" onSubmit={handleSubmit} enctype="multipart/form-data">
      <div className="w-full md:w-1/2 pb-4">
        <p className="text-2xl">Información personal</p>
      </div>
      <div className="w-full md:w-1/2 pb-8">
        <input
          className="border focus:outline-none shadow-lg py-2 px-4 mb-4 rounded-3xl w-full md:w-4/6 border-gray-700 text-primary"
          placeholder="Nombre Completo"
          type="text"
          name="full_name"
          id="full_name"
          onChange={({ target }) => setFullName(target.value)}
          value={fullName}
          required
        />
        <input
          className="border focus:outline-none shadow-lg py-2 px-4 mb-4 rounded-3xl w-full md:w-4/6 border-gray-700 text-primary"
          placeholder="e-mail"
          type="email"
          name="email"
          id="email"
          onChange={({ target }) => setEmail(target.value)}
          value={email}
          required
        />
        <input
          className="border focus:outline-none shadow-lg py-2 px-4 mb-4 rounded-3xl w-full md:w-4/6 border-gray-700 text-primary"
          placeholder="linkedin"
          type="text"
          name="linkedin"
          id="linkedin"
          onChange={({ target }) => setLinkedin(target.value)}
          value={linkedin}
        />
      </div>

      <div className="w-full md:w-1/2 pb-4">
        <p className="text-2xl">Resume/CV</p>
      </div>
      <div className="w-full md:w-1/2 pb-8">
        <label
          htmlFor="file-upload"
          className="cursor-pointer border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn w-full md:w-4/6 text-center block mt-0 mb-2 py-2"
        >
          <input
            id="file-upload"
            name="file-upload"
            type="file"
            accept=".doc,.docx,.pdf"
            className="sr-only sm:not-sr-only"
            onChange={handleChangeUploadResume}
          />
          <span>
            <FaUpload className="inline mr-2" /> Upload a file
          </span>
        </label>
        <p className="block italic text-sm text-center md:text-left">
          We accept PDF, DOC and DOCX files.
        </p>
      </div>

      <div className="w-full md:w-1/2 pb-4">
        <p className="text-2xl">Queremos saber más de vos</p>
      </div>
      <div className="w-full md:w-1/2">
        <textarea
          name="message"
          id="message"
          className="border focus:outline-none shadow-lg py-2 px-4 mb-4 rounded-3xl w-full md:w-4/6 border-gray-700 text-primary"
          rows="5"
          onChange={({ target }) => setMessage(target.value)}
          value={message}
        ></textarea>
      </div>

      <div className="w-full">
        <button
          type="submit"
          className="btn hover:text-variant font-semibold py-2 px-4 rounded-lg transition duration-300 ease-in-out hover:bg-neutral hover:text-primary mx-auto block bg-secondary" 
        >
          <svg
            className={
              loading
                ? `h-5 w-5 mr-3 animate-spin inline`
                : `h-5 w-5 mr-3 hidden`
            }
            viewBox="0 0 24 24"          
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          Send it
        </button>
      </div>
      {/*TODO: Mapear esto, se repite mucho*/}
      <div className="w-full text-center">
        <p className="pb-4 text-xl">Compartí esta búsqueda</p>
        <a
          href="https://www.linkedin.com/company/avalith-net"
          title="Avalith in Linkedin"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedin className="text-3xl inline-block mr-6 text-secondary hover:text-white transition duration-500 ease-in-out" />
        </a>
        <a
          href="https://www.facebook.com/avalith.net"
          title="Avalith in Facebook"
          target="_blank"
          rel="noreferrer"
        >
          <FaFacebook className="text-3xl inline-block mr-6 text-secondary hover:text-white transition duration-500 ease-in-out" />
        </a>
        <a
          href="https://www.instagram.com/avalithar"
          title="Avalith in Instagram"
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram className="text-3xl inline-block mr-6 text-secondary hover:text-white transition duration-500 ease-in-out" />
        </a>
        <a
          href="https://www.avalith.net"
          target="_blank"
          title="Avalith in Twitter"
          rel="noreferrer"
        >
          <FaTwitter className="text-3xl inline-block mr-6 text-secondary hover:text-white transition duration-500 ease-in-out" />
        </a>
      </div>
    </form>
  )
}

Form.propTypes = {
  handleSubmit: PropTypes.func,
  fullName: PropTypes.string,
  setFullName: PropTypes.func,
  email: PropTypes.string,
  setEmail: PropTypes.func,
  linkedin: PropTypes.string,
  setLinkedin: PropTypes.func,
  handleChangeUploadResume: PropTypes.func,
  message: PropTypes.string,
  setMessage: PropTypes.func,
  loading: PropTypes.bool,
}

export default Form
